import { Outlet, useNavigation } from "react-router-dom"
import Navbar from "./Navbar"
import Footer from "./Footer"
import Loader from "./Loader"
import "./styles/AppLayout.css"

function AppLayout() {
    const navigation = useNavigation()
    const isLoading = navigation.state === 'loading'

    return (
        <div className="app-layout">
            {isLoading && <Loader />}
            <header className="header-container"> 
                <Navbar />
            </header>
            <main className="main-content">
                <Outlet />
            </main>
            <footer className="footer">
                <Footer />
            </footer>
        </div>
    )
}

export default AppLayout
